import React from 'react';
import { BanknoteIcon, BuildingIcon, CheckIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { formatRwf } from '../../../utils/currency';
const methods = [{
  label: 'Mobile money',
  icon: SmartphoneIcon,
  amount: 20000,
  status: 'Paid'
}, {
  label: 'Cash',
  icon: BanknoteIcon,
  amount: 8500,
  status: 'Paid'
}, {
  label: 'Card',
  icon: CreditCardIcon,
  amount: 0,
  status: ''
}, {
  label: 'Bank transfer',
  icon: BuildingIcon,
  amount: 0,
  status: ''
}];
export function PaymentsScreen() {
  const total = 28500;
  const paid = methods.reduce((s, m) => s + m.amount, 0);
  return <div className="w-full max-w-[380px] rounded-[14px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-1275" data-mp="k6p9y0br455y">
      <div className="flex items-baseline justify-between" data-id="element-1276" data-mp="p5a9ryn3cmtv">
        <p className="text-[14px] font-semibold text-ink" data-id="element-1277" data-mp="u5euk0v183pw">Split payment</p>
        <span className="text-[12px] text-ink-muted" data-id="element-1278" data-mp="u3bsujkiom5c">Bill {formatRwf(total)}</span>
      </div>
      <ul className="mt-4 space-y-2" data-id="element-1279" data-mp="y79rkt5xjuxv">
        {methods.map(m => {
        const Icon = m.icon;
        const active = m.amount > 0;
        return <li key={m.label} className={`flex items-center gap-3 rounded-[10px] border px-3 py-2.5 ${active ? 'border-brand/40 bg-brand-soft/60' : 'border-canvas-line'}`} data-id="element-1280" data-mp="2esxjqtk4btwr">
              <span className={`flex h-8 w-8 items-center justify-center rounded-[8px] ${active ? 'bg-white text-brand' : 'bg-canvas-warm text-ink-muted'}`} data-id="element-1281" data-mp="24x424vrjla84">
                <Icon className="h-4 w-4" aria-hidden="true" data-id="element-1282" data-mp="2xkq4k0p1a8te" />
              </span>
              <span className="flex-1 text-[13px] font-medium text-ink" data-id="element-1283" data-mp="2ssgkh1alo2z1">{m.label}</span>
              {active ? <span className="flex items-center gap-2 text-[13px] font-semibold text-ink" data-id="element-1284" data-mp="2nsu62oj1cgon">
                  {formatRwf(m.amount)}
                  <span className="flex h-4 w-4 items-center justify-center rounded-full bg-[#1B7A3D]" data-id="element-1285" data-mp="3lbcb1nje3l1a">
                    <CheckIcon className="h-2.5 w-2.5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-1286" data-mp="3ggg7pr8pdb8v" />
                  </span>
                </span> : <span className="text-[12px] text-ink-muted" data-id="element-1287" data-mp="1jisf1t7y6hvp">Add</span>}
            </li>;
      })}
      </ul>
      <div className="mt-4 flex items-center justify-between rounded-[10px] bg-canvas-warm px-3 py-2.5" data-id="element-1288" data-mp="14td0dbloy2wd">
        <span className="text-[12px] text-ink-muted" data-id="element-1289" data-mp="19rxqgi78b673">Remaining</span>
        <span className="text-[14px] font-semibold text-[#1B7A3D]" data-id="element-1290" data-mp="vsy3dezd6zd1">
          {paid >= total ? 'Fully paid' : formatRwf(total - paid)}
        </span>
      </div>
    </div>;
}